var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.2")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.17 0 0 4.17 200 200)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(41,182,246)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.17 0 0 4.17 191.67 202.08)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-22, -24.5)",
    d: "M 33.95 15 l -3.746 19.126 c 0 0 -0.161 0.874 -1.245 0.874 c -0.576 0 -0.873 -0.274 -0.873 -0.274 l -8.114 -6.733 l -3.97 -2.001 l -5.095 -1.355 c 0 0 -0.907 -0.262 -0.907 -1.012 c 0 -0.625 0.933 -0.923 0.933 -0.923 l 21.316 -8.468 c -0.001 -0.001 0.651 -0.235 1.126 -0.234 C 33.667 14 34 14.125 34 14.5 C 34 14.75 33.95 15 33.95 15 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.17 0 0 4.17 187.51 229.15)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(176,190,197)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21, -31)",
    d: "M 23 30.505 l -3.426 3.374 c 0 0 -0.149 0.115 -0.348 0.12 c -0.069 0.002 -0.143 -0.009 -0.219 -0.043 l 0.964 -5.965 L 23 30.505 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.17 0 0 4.17 195.83 208.24)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(207,216,220)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23, -25.98)",
    d: "M 29.897 18.196 c -0.169 -0.22 -0.481 -0.26 -0.701 -0.093 L 16 26 c 0 0 2.106 5.892 2.427 6.912 c 0.322 1.021 0.58 1.045 0.58 1.045 l 0.964 -5.965 l 9.832 -9.096 C 30.023 18.729 30.064 18.416 29.897 18.196 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.042acb32e417d2387c3720d088c514e8.svg";
export { ForwardRef as ReactComponent };